// extracted by mini-css-extract-plugin
export default {"zine":"Zine_zine__ifY2+"};